function a11yController() {
  skipToMainContent();
  
  const allBlankLinks = document.querySelectorAll('[target="_blank"]');

  allBlankLinks.forEach((link) => {
    const shouldAddElement = ![...link.children].some((child) =>
      child.classList.contains('sr-only') && child.innerText.toLowerCase() === 'opens in new tab'
    );

    if (shouldAddElement) {
      const screenReaderIndicator = document.createElement('span');
      screenReaderIndicator.classList.add('sr-only');
      screenReaderIndicator.textContent = 'Opens in new tab';
  
      link.appendChild(screenReaderIndicator);
    }
  });

  const allButtonLinks = document.querySelectorAll('a[href="#"]');

  allButtonLinks.forEach((link) => {
    if (!link.role) {
      link.role = "button";
    }
  });

  if (window.location.href.endsWith("/contact/")) addAriaLabels();
  if (window.location.href.endsWith("/team/")) setDropdowns();
  if (window.location.href.endsWith("/blog/")) circualModalTabbing();

  const heroHomepage = document.querySelector('.block-hero-homepage');

  if (heroHomepage) {
    const heroHomepageCta = heroHomepage.querySelector('.block-hero-homepage__cta-button .c-btn');

    if (heroHomepageCta) {
      heroHomepageCta.ariaLabel = heroHomepageCta.innerText;
    }
  }
}

function circualModalTabbing() {
  const lastButton = document.querySelector('.eight29-app .eight29-sidebar-toggle.apply-filters');

  if (lastButton) {
    lastButton.addEventListener('focusout', (e) => {
      if (!matchMedia('(min-width: 992px)').matches) {
        const topButton = document.querySelector('.eight29-app .eight29-sidebar-content__top_header .eight29-sidebar-close');
        console.log(e.target, topButton);
        topButton.focus();
      }
    });
  }
}

function setDropdownElementsState(state, elements) {
  if (state === 'active' || state === 'inactive') {
    elements.forEach((elements) => {
      if (state === 'inactive') {
        elements.tabIndex = -1;
        elements.ariaHidden = true;
      }
      else if (state === 'active') {
        elements.tabIndex = 0;
        elements.ariaHidden = false;
      }
    });
  }
}

function skipToMainContent() {
  const mainContentButton = document.querySelector('.skip-to-main__wrapper .skip-to-main');

  if (mainContentButton) {
    mainContentButton.addEventListener('click', (e) => {
      e.preventDefault();

      const header = document.querySelector('.main-header');
      const mainContent = header.nextElementSibling.nextElementSibling;

      e.target.blur();
      mainContent.tabIndex = 0;
      mainContent.focus();
      mainContent.tabIndex = -1;
    });
  }
}


function setDropdowns() {
  const buttons1 = document.querySelectorAll('.eight29-app .eight29-filter-list .eight29-filter:first-child .dropdown-list button');
  const buttons2 = document.querySelectorAll('.eight29-app .eight29-filter-list .eight29-filter:last-child .dropdown-list button');
  const lists = document.querySelectorAll('.eight29-app .dropdown-container .simplebar-content-wrapper');

  const elements = [...buttons1, ...buttons2, ...lists];
  
  if (elements.length > 0) {
    setDropdownElementsState('inactive', elements);
  }

  buttons1[buttons1.length - 1].addEventListener('keydown', (e) => {
    if (e.key === 'Tab' && !e.shiftKey) {
      e.target.closest('.dropdown-container').classList.remove('open');
      setDropdownElementsState('inactive', elements);
    }
  });

  buttons2[buttons2.length - 1].addEventListener('keydown', (e) => {
    if (e.key === 'Tab' && !e.shiftKey) {
      e.target.closest('.dropdown-container').classList.remove('open');
      setDropdownElementsState('inactive', elements);
    }
  });
}

function addAriaLabels() {
  // Get the required elements
  const socialIcons = document.querySelectorAll('.block-hero-contact .is-style-social');

  if (socialIcons.length > 0) {
    for (const icon of socialIcons) {
      const iconName = icon.getAttribute('style');
      const label = iconName.split('(')[1].split('-')[3].split(')')[0];
      const finalLabel = 'Connect on ' + label.charAt(0).toUpperCase() + label.slice(1);
      icon.children[0].ariaLabel = finalLabel;
    }
  }
}

export default a11yController;